module.exports = __webpack_public_path__ + "img/shipment_confirmation.b81bac99.svg";